import Typography from "@mui/material/Typography";

type TimeProps = {
	time: Date;
	isEta: boolean;
};

export const Time = ({ time, isEta }: TimeProps) => {
	return (
		<>
			{isEta && (
				<>
					<Typography variant="caption" sx={{ fontStyle: "italic" }}>
						Expected
					</Typography>
					<br />
				</>
			)}
			<b>{time.toLocaleTimeString(undefined, { timeStyle: "short" })}</b>{" "}
			{time.toLocaleDateString(undefined, { dateStyle: "short" })}
		</>
	);
};
